export default __webpack_public_path__ + "static/media/Excellent Quality.73f3a0da.svg";